<template>
    <div class="session__list_calendar">
        <div class="container">
            <div class="columns is-variable">
                <div class="column is-narrow">
                    <calendar-datepicker @datepicker-selected="datepickerSelected"/>
                </div>
                <div class="column is-narrow">
                    <div class="calendar__separator"></div>
                </div>
                <div class="column">
                    <calendar-calendar ref="calendarCalendar" :sessions="sessions"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CalendarCalendar from '@/components/ebs/calendar/CalendarCalendar'
import CalendarDatepicker from '@/components/ebs/calendar/CalendarDatepicker'

export default {
  components: {
    CalendarDatepicker,
    CalendarCalendar
  },
  name: 'session-list-calendar',
  props: {
    sessions: {
      type: [Array, Object]
    }
  },
  methods: {
    datepickerSelected: function (date) {
      this.$refs.calendarCalendar.updateDate(date)
    }
  }
}
</script>
